export default "__VITE_ASSET__hhYe8Lj___"